export const fancyboxConfig = {
    placeFocusBack: false,
    Carousel: {
        infinite: true,
    },
};
